import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
// import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, skip, take, takeUntil } from 'rxjs/operators';

import { UpdateDurationFilter } from 'src/app/home/actions/duration-filter.actions';
import { getDurationFilterState, getHomeTags, State } from 'src/app/home/reducers';

import { SevereViolationsData } from 'src/app/home/models/home.model';
import { CONFIGS_WITH_SUBCONFIGS, EVENTS_CONFIG } from '@app-core/constants/constants';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { DateService } from '@app-core/services/date/date.service';
import { GoogleTagManagerService, ToggleState } from '@app-core/services/google-tag-manager/google-tag-manager.service';
import { TranslateService } from '@ngx-translate/core';
import { HomeService } from '../../services/home.service';
import { environment } from '@env/environment';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackwidgetComponent } from '@app-shared/components/feedback-widget/feedback-widget.component';
import { FormControl } from '@angular/forms';
import { AnnouncementBannerComponent } from '@app-home/components/announcement-banner/announcement-banner.component';
import { getClientConfig } from '@config/client-config';
import { UpdateHomeTagsFilter } from '@app-home/actions/home-filter-tags.action';
import { Days, DurationRange, FleetEvents } from '@app-core/models/core.model';
import { DurationRangeService } from '@app-core/services/duration-range/duration-range.service';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';
import { AssetDriverSelectionModalComponent } from '@app-shared/components/asset-driver-selection-modal/asset-driver-selection-modal.component';

@Component({
  selector: 'app-triaging',
  templateUrl: './triaging.component.html',
  styleUrls: ['./triaging.component.scss'],
})
export class TriagingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('paginator')
  public CONFIGS_WITH_SUBCONFIGS = CONFIGS_WITH_SUBCONFIGS;
  public CLIENT_CONFIG: any;
  public EVENTS_CONFIG = EVENTS_CONFIG;
  public paginator: MatPaginator;
  public durationTitle: string;
  public durationList = this.durationService.getDurationList();
  public durationRange: DurationRange;
  public fleetStats = {
    tripCount: 0,
    distance: 0,
    eventsPer100Units: 0,
    totalEventsDiff: 0,
    tripDuration: 0,
  };
  public eventDiff = [];
  public safeDriverList = [];
  public unSafeDriverList = [];
  public driverListTitle = 'Driver list';
  public safeDriversTitle = 'Top Drivers';
  public unSafeDriversTitle = 'Require Coaching';
  public showTopIncident = true;
  public currentTimeZone: string;
  public severeFleetViolations: SevereViolationsData;
  public selectedTags: string[] = [];
  public clientConfig = getClientConfig().configuration;

  public loginName: string;
  public fleetId: string;

  public startDate: string;
  public endDate: string;
  public fleetEventLoader = true;
  public driverListLoader = true;
  public fleetStatsLoader = true;
  public currentMetricUnit = null;
  public currentDateFormat = null;
  public currentTheme = 'light';
  public isDevEnv = environment?.env === 'dev' ? true : false;
  public feedbackButtonLoader = false;
  public coachingRecommendLoader = false;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public highlightsEventType = new FormControl('');
  public eventList = [];
  public currentTabIndex: number;
  public isFeedbackWidgetOpen = false;
  public coachableDriverList = [];

  public alert = {
    showAlert: false,
    alertMessage: '',
    alertType: '',
  };
  public modifiedEventList;
  private ngUnsubscribeOnChanges: Subject<void> = new Subject<void>();
  public tagIds: any[];
  public homeTags: any[];

  // private limit = 5;
  public topDriversOffset: number = 0;
  public coachableDriversOffset: number = 0;
  public topDriversTotalCount: number;
  public coachableDriversTotalCount: number;
  public highlightsData: SevereViolationsData;
  public highlightsSubEventType = new FormControl('');
  public displaySubEventSelection: boolean;
  public subEventList = [];
  public fleetEvents: FleetEvents;
  public plans: string;

  /**
   *  Inject analytics, access and date services
   */
  constructor(
    private store: Store<State>,
    private homeService: HomeService,
    private accessService: AccessService,
    private dateService: DateService,
    private gtmService: GoogleTagManagerService,
    public dataService: DataService,
    public translate: TranslateService,
    private dialog: MatDialog,
    public durationService: DurationRangeService,
    private mixpanelService: MixPanelService
  ) {
    Promise.resolve().then(() => {
      this.CLIENT_CONFIG = getClientConfig().configuration;
    });
  }

  /**
   * Get currently applied filter data from the store
   *
   * Get login name and fleet ID of the logged in user
   *
   * Call getData function
   */
  public ngOnInit() {
    ({ loginName: this.loginName } = this.accessService.getLoginInfo());

    this.store
      .select(getDurationFilterState)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((durationFilterState) => {
        const { days, startDate, endDate } = durationFilterState;
        this.durationRange = { days, startDate, endDate };
        this.startDate = this.dateService.toDaysStartISO(startDate);
        this.endDate = this.dateService.toDaysEndISOPlusOne(endDate);
        if (this.startDate && this.endDate && this.currentMetricUnit) {
          // this.getData();
        }
        this.durationTitle = this.getDurationTitle(this.durationRange.days);
      });

    this.dataService._currentMetricUnit.subscribe((value: string) => {
      if (value) {
        this.currentMetricUnit = value;
        // if (this.startDate && this.endDate && this.currentMetricUnit) {
        //   this.getData();
        // }
      }
    });

    this.dataService._currentTimeZone.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.currentTimeZone = value;
      }
    });

    this.dataService._currentDateFormat.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.currentDateFormat = value;
      }
    });

    this.dataService._currentTheme.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.currentTheme = value;
      }
    });

    this.dataService._currentFleet.pipe(takeUntil(this.ngUnsubscribe), take(1)).subscribe((value: string) => {
      if (value) {
        this.fleetId = value;
      }
    });

    this.dataService._currentFleet.pipe(takeUntil(this.ngUnsubscribe), skip(1)).subscribe((value: string) => {
      if (value) {
        this.fleetId = value;
        // this.getData();
      }
    });
    this.store
      .select(getHomeTags)
      .pipe(takeUntil(this.ngUnsubscribeOnChanges))
      .subscribe((tagFilter) => {
        const { tagIds } = tagFilter;
        this.tagIds = tagIds;
      });
    this.homeTags = this.tagIds.length
      ? this.tagIds.map((tagid) => ({ tagId: tagid }))
      : this.homeService?.tagIds.map((tagid) => ({ tagId: tagid }));
    this.plans = this.durationService.planDetails?.plan;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const { fleets } = this.accessService.getLoginInfo() || {};
      if (fleets?.[0]?.role?.isAdmin) {
        this.openAssetDriverSelectionModal();
      }
    });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.ngUnsubscribeOnChanges.next();
    this.ngUnsubscribeOnChanges.complete();
  }

  public openAssetDriverSelectionModal() {
    this.getFleetDetailsForDriverAndAssetCentric().subscribe((metadata) => {
      if (!metadata) {
        this.dialog.open(AssetDriverSelectionModalComponent, {
          panelClass: ['asset-driver-modal', 'mobile-modal'],
          position: { top: '24px', bottom: '24px' },
          autoFocus: false,
          disableClose: true,
          data: {
            metadata: metadata,
          },
        });
      }
    });
  }

  getFleetDetailsForDriverAndAssetCentric(): Observable<any> {
    return this.dataService.getFleetDetails().pipe(
      map((res) => {
        return res?.metadata;
      })
    );
  }

  /**
   * Function binded to duration filter change output event
   *
   * Dispatch update duration filter action
   */
  public changeDuration(duration: DurationRange): void {
    const { days, startDate, endDate } = duration;
    this.store.dispatch(new UpdateDurationFilter({ days, startDate, endDate }));
    const durationTitle = this.getDurationTitle(days);
    this.gtmService.changeFleetOverviewDurationFilter(durationTitle, days);
    this.mixpanelService.track('Select date range in home page', {
      'Duration Title': durationTitle,
      Days: days,
      'Event Name': 'Select date range in home page',
      'Page Name': 'Home Page',
      'Action Type': 'select',
    });
  }
  private getDurationTitle(days: Days) {
    const index = this.durationList.findIndex((d) => d.days === days);
    return index > -1 ? this.durationList[index].title : '';
  }
  public viewAnnouncementDetails() {
    this.dialog.open(AnnouncementBannerComponent, {
      width: '640px',
      minHeight: '240px',
      position: {
        top: '24px',
      },
      panelClass: ['mobile-modal'],
      autoFocus: false,
      disableClose: false,
    });
  }
  public changeSearchByTags(tags: any): void {
    let overViewTags;
    if (tags) {
      overViewTags = tags.join(' + ');
      this.homeService.tagIds = tags;
      this.store.dispatch(new UpdateHomeTagsFilter({ tagIds: tags }));
      this.gtmService.changeFleetOverviewTags(overViewTags);
      this.mixpanelService.track('Select tag in Home Page', {
        'Tag Value': overViewTags,
      });
    }
    this.selectedTags = tags;
  }
  public openFeedbackWidget() {
    this.feedbackButtonLoader = true;
    this.dialog.closeAll();
    this.isFeedbackWidgetOpen = true;
    const dialogRef = this.dialog.open(FeedbackwidgetComponent, {
      position: {
        bottom: '96px',
        right: '32px',
      },
      width: '400px',
      height: '480px',
      autoFocus: false,
      disableClose: false,
      hasBackdrop: false,
      closeOnNavigation: true,
      panelClass: ['mobile-modal'],
    });
    this.gtmService.toggleFeedbackWidget(ToggleState.show);
    this.feedbackButtonLoader = false;
    dialogRef.afterClosed().subscribe(() => {
      this.gtmService.toggleFeedbackWidget(ToggleState.hide);
      this.isFeedbackWidgetOpen = false;
    });
  }
  public closeFeedbackWidget() {
    this.isFeedbackWidgetOpen = false;
    this.dialog.closeAll();
  }
}
